// extracted by mini-css-extract-plugin
module.exports = {"feedbackButton":"style__feedbackButton__I6Gl+"};